let BASE_URL;let DZ_FACTOR_SORTING_URL; let QUOTE_BASE_URL; let OSS_URL; let GC_PROD_URL; let GC_PAY_URL; let GC_ACCESS_URL; let GC_LIVEROOM_URL; let GC_CHATROOM_URL; let GC_COURSE; let
  ACCOUNT_TYPE = 1000;
// @ts-ignore
console.log('ENV', ENV);
let GS_TC_URL = 'http://gcts-wechat.beta.shrise.cn/';
const QT_WEB_HTTP_URL = 'https://q-api.shrise.cn';// 行情web
let WS_URL = 'wss://quote-gateway.cf69.cn';
const YOURUI_URL = 'https://quote.youruitech.com';
let DZ_BASE_URL = 'https://dz-app-gateway.cf69.com';
let DZ_WS_URL = 'wss://dz-app-gateway.cf69.com';
let MOCK_URL = 'http://127.0.0.1:4523/m1/4312044-5210081-default';
let F10_URL = 'https://dz-f10.cf69.com';


switch (ENV) {
  case 'beta0':
    BASE_URL = 'https://api-web-beta0.shrise.cn';
    QUOTE_BASE_URL = 'https://api-quote-v0.shrise.cn';
    OSS_URL = 'https://tj-file-oss.cf69.com/';
    GC_ACCESS_URL = 'https://gc-access-beta0.shrise.cn/';
    GC_PROD_URL = 'https://gc-prod-beta0.shrise.cn/';
    GC_PAY_URL = 'https://gc-pay-beta0.shrise.cn/';
    GC_CHATROOM_URL = 'https://gc-chatroom-beta0.shrise.cn/';
    GC_COURSE = 'https://gc-course-beta0.shrise.cn/';
    WS_URL = 'wss://quote-gateway-beta0.shrise.cn/';
    DZ_FACTOR_SORTING_URL = 'https://dianzheng-api.shrise.cn/api';
    break;
  case 'beta1':
    BASE_URL = 'https://api-web-beta1.shrise.cn';
    QUOTE_BASE_URL = 'https://api-quote-v1.shrise.cn';
    OSS_URL = 'https://tj-file-oss.cf69.com/';
    GC_ACCESS_URL = 'https://gc-access-beta1.shrise.cn/';
    GC_PROD_URL = 'https://gc-prod-beta1.shrise.cn/';
    GC_PAY_URL = 'https://gc-pay-beta1.shrise.cn/';
    GC_LIVEROOM_URL = 'https://gc-liveroom-beta1.shrise.cn/';
    GC_CHATROOM_URL = 'https://gc-chatroom-beta1.shrise.cn/';
    GC_COURSE = 'https://gc-course-beta1.shrise.cn/';
    WS_URL = 'wss://quote-gateway-beta1.shrise.cn/';
    DZ_FACTOR_SORTING_URL= 'https://dianzheng-api.shrise.cn/api';
    ACCOUNT_TYPE = 1099;
    break;
  case 'beta2':
    BASE_URL = 'https://api-web-beta2.shrise.cn';
    QUOTE_BASE_URL = 'https://api-quote-v2.shrise.cn';
    OSS_URL = 'https://tj-file-oss.cf69.com/';
    GC_ACCESS_URL = 'https://gc-access-beta2.shrise.cn/';
    GC_PROD_URL = 'https://gc-prod-beta2.shrise.cn/';
    GC_PAY_URL = 'https://gc-pay-beta2.shrise.cn/';
    GC_LIVEROOM_URL = 'https://gc-liveroom-beta2.shrise.cn/';
    GC_CHATROOM_URL = 'https://gc-chatroom-beta2.shrise.cn/';
    GC_COURSE = 'https://gc-course-beta2.shrise.cn/';
    WS_URL = 'wss://quote-gateway-beta1.shrise.cn/';
    DZ_FACTOR_SORTING_URL = 'https://dianzheng-api.shrise.cn/api';
    ACCOUNT_TYPE = 1000;
    break;
  case 'beta3':
    BASE_URL = 'https://api-web-beta3.shrise.cn';
    QUOTE_BASE_URL = 'https://api-quote-v3.shrise.cn';
    OSS_URL = 'https://tj-file-oss.cf69.com/';
    GC_ACCESS_URL = 'https://gc-access-beta3.shrise.cn/';
    GC_PROD_URL = 'https://gc-prod-beta3.shrise.cn/';
    GC_PAY_URL = 'https://gc-pay-beta3.shrise.cn/';
    GC_LIVEROOM_URL = 'https://gc-liveroom-beta3.shrise.cn/';
    GC_CHATROOM_URL = 'https://gc-chatroom-beta3.shrise.cn/';
    GC_COURSE = 'https://gc-course-beta3.shrise.cn/';
    WS_URL = 'wss://quote-gateway-beta3.shrise.cn/';
    DZ_FACTOR_SORTING_URL = 'https://dianzheng-api.shrise.cn/api';
    ACCOUNT_TYPE = 1001;
    break;
  case 'beta4':
    // DZ_BASE_URL = 'https://dz-app-gateway-mock.shrise.cn';
    // DZ_WS_URL = 'ws://dz-app-gateway-mock.shrise.cn';
    BASE_URL = 'https://api-web-beta4.shrise.cn';
    QUOTE_BASE_URL = 'https://api-quote.cf69.cn';
    OSS_URL = 'https://tj-file-oss.cf69.com/';
    GC_ACCESS_URL = 'https://gc-access-beta4.shrise.cn/';
    GC_PROD_URL = 'https://gc-prod-beta4.shrise.cn/';
    GC_PAY_URL = 'https://gc-pay-beta4.shrise.cn/';
    GC_LIVEROOM_URL = 'https://gc-liveroom-beta4.shrise.cn/';
    GC_CHATROOM_URL = 'https://gc-chatroom-beta4.shrise.cn/';
    GC_COURSE = 'https://gc-course-beta4.shrise.cn/';
    WS_URL = 'wss://quote-gateway.cf69.cn';
    DZ_FACTOR_SORTING_URL = 'https://dianzheng-api.shrise.cn/api';
    ACCOUNT_TYPE = 1002;
    break;
  case 'beta5':
    BASE_URL = 'https://api-web-beta5.shrise.cn';
    QUOTE_BASE_URL = 'https://api-quote-v5.shrise.cn';
    OSS_URL = 'http://tj-file-oss.cf69.com/';
    GC_ACCESS_URL = 'https://gc-access-beta5.shrise.cn/';
    GC_PROD_URL = 'https://gc-prod-beta5.shrise.cn/';
    GC_PAY_URL = 'https://gc-pay-beta5.shrise.cn/';
    GC_LIVEROOM_URL = 'https://gc-liveroom-beta5.shrise.cn/';
    GC_CHATROOM_URL = 'https://gc-chatroom-beta5.shrise.cn/';
    GC_COURSE = 'https://gc-course-beta5.shrise.cn/';
    WS_URL = 'wss://quote-gateway-beta1.shrise.cn/';
    DZ_FACTOR_SORTING_URL = 'https://dianzheng-api.shrise.cn/api';
    ACCOUNT_TYPE = 1002;
    break;
  case 'beta6':
    BASE_URL = 'https://api-web-beta6.shrise.cn';
    QUOTE_BASE_URL = 'https://api-quote-v6.shrise.cn';
    OSS_URL = 'http://tj-file-oss.cf69.com/';
    GC_ACCESS_URL = 'https://gc-access-beta6.shrise.cn/';
    GC_PROD_URL = 'https://gc-prod-beta6.shrise.cn/';
    GC_PAY_URL = 'https://gc-pay-beta6.shrise.cn/';
    GC_LIVEROOM_URL = 'https://gc-liveroom-beta6.shrise.cn/';
    GC_CHATROOM_URL = 'https://gc-chatroom-beta6.shrise.cn/';
    GC_COURSE = 'https://gc-course-beta6.shrise.cn/';
    WS_URL = 'wss://quote-gateway-beta6.shrise.cn/';
    DZ_FACTOR_SORTING_URL = 'https://dianzheng-api.shrise.cn/api';
    ACCOUNT_TYPE = 1002;
    break;
  default:
    DZ_BASE_URL = 'https://dz-app-gateway.cf69.com';
    DZ_WS_URL = 'wss://dz-app-gateway.cf69.com';
    BASE_URL = 'https://api-web.cf69.cn';
    QUOTE_BASE_URL = 'https://api-quote.cf69.cn';
    OSS_URL = 'https://tj-file-oss.cf69.com/';
    GS_TC_URL = 'https://wxts.cf69.cn/';
    GC_ACCESS_URL = 'https://gc-access.cf69.cn/';
    GC_PROD_URL = 'https://gc-prod.cf69.cn/';
    GC_PAY_URL = 'https://gc-pay.cf69.cn/';
    GC_LIVEROOM_URL = 'https://gc-liveroom-02.cf69.com/';
    GC_CHATROOM_URL = 'https://gc-chatroom.cf69.cn/';
    GC_COURSE = 'https://gc-course.cf69.cn/';
    DZ_FACTOR_SORTING_URL = 'https://dianzheng-api.cf69.com';
    F10_URL = 'https://dz-f10.cf69.com';
    ACCOUNT_TYPE = 1099;
}


const PRODUCT_TYPE = 170;
const COMPANY_TYPE = 45;
const WHITE_PAGE_LIST = ['/authorization', '/short-invalid', '/use-guide'];

export default {
  DZ_BASE_URL,
  DZ_WS_URL,
  ACCOUNT_TYPE,
  PRODUCT_TYPE,
  GC_PAY_URL,
  GS_TC_URL,
  GC_PROD_URL,
  BASE_URL,
  QUOTE_BASE_URL,
  OSS_URL,
  QT_WEB_HTTP_URL,
  GC_ACCESS_URL,
  WHITE_PAGE_LIST,
  COMPANY_TYPE,
  GC_LIVEROOM_URL,
  GC_CHATROOM_URL,
  GC_COURSE,
  WS_URL,
  YOURUI_URL,
  MOCK_URL,
  DZ_FACTOR_SORTING_URL,
  F10_URL,
};
